import { render, staticRenderFns } from "./integrations-summary-list.vue?vue&type=template&id=50e8c04a&"
import script from "./integrations-summary-list.vue?vue&type=script&lang=js&"
export * from "./integrations-summary-list.vue?vue&type=script&lang=js&"
import style0 from "./integrations-summary-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports